export const asAngleUp = {
  data: `<svg width="8" height="5" viewBox="0 0 8 5" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4.21875 0.210938L7.40625 3.39844C7.61719 3.63281 7.61719 3.98438 7.40625 4.19531L6.86719 4.73438C6.65625 4.94531 6.28125 4.94531 6.07031 4.73438L3.82031 2.46094L1.54688 4.73438C1.33594 4.94531 0.984375 4.94531 0.75 4.73438L0.234375 4.19531C0 3.98438 0 3.63281 0.234375 3.39844L3.42188 0.210938C3.63281 0 3.98438 0 4.21875 0.210938Z" fill="currentColor"/>
</svg>
`,
  name: 'angleUp',
};
